import { createIcon } from "@chakra-ui/react";

export const Stacked = createIcon({
  displayName: "EukaStacked",
  viewBox: "0 0 82 114",
  path: [
    <path
      key="1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.861084 68.8381H18.5544V72.4697H4.95893V80.4044H15.9535V84.036H4.95893V92.8384H18.9877V96.4703H0.861084V68.8381Z"
      fill="currentColor"
    />,
    <path
      key="2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.2537 86.957L48.7712 89.2466V96.4702H44.9094V68.2461H48.7712V84.5098L57.401 76.5752H62.366L54.0118 84.3516L63.1148 96.4702H58.3859L51.2537 86.957Z"
      fill="currentColor"
    />,
    <mask
      key="3"
      id="mask0_5892_20983"
      maskUnits="userSpaceOnUse"
      x="64"
      y="76"
      width="18"
      height="21"
    >
      <path
        d="M64.7705 76.2595H81.8333V96.7863H64.7705V76.2595Z"
        fill="white"
      />
    </mask>,
    <g key="4" mask="url(#mask0_5892_20983)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.8334 83.6413V96.4703H78.0109V93.2337C77.065 95.3654 74.5432 96.7863 71.5483 96.7863C67.4894 96.7863 64.8101 94.3392 64.8101 90.7859C64.8101 86.9571 67.8439 84.5882 72.5335 84.5882H76.6709C77.577 84.5882 78.0109 84.1149 78.0109 83.4044C78.0109 80.9963 76.2769 79.3385 73.2032 79.3385C70.4448 79.3385 68.4351 81.0752 68.317 83.0887H64.7705C65.0854 79.1806 68.6319 76.2595 73.3216 76.2595C78.4442 76.2595 81.8334 79.2199 81.8334 83.6413ZM78.0109 87.7465V87.2732H72.888C70.2874 87.2732 68.5927 88.6149 68.5927 90.7073C68.5927 92.5229 70.0903 93.7466 72.2971 93.7466C75.9221 93.7466 78.0109 91.4177 78.0109 87.7465Z"
        fill="currentColor"
      />
    </g>,
    <path
      key="5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833252 102.428H5.88905V103.163H1.6267V106.152H5.11927V106.887H1.6267V110.73H0.833252V102.428Z"
      fill="currentColor"
    />,
    <path
      key="6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6535 110.73H10.9077V109.485C10.6 110.386 9.84253 110.825 8.89478 110.825C7.54521 110.825 6.66907 109.864 6.66907 108.382V104.753H7.41517V108.286C7.41517 109.401 8.04261 110.137 9.00175 110.137C10.1146 110.137 10.9077 109.235 10.9077 107.966V104.753H11.6535V110.73Z"
      fill="currentColor"
    />,
    <path
      key="7"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6829 102.796V104.753H16.5769V105.44H14.6829V108.939C14.6829 109.627 15.0739 110.042 15.6771 110.042H16.5769V110.73H15.6894C14.6122 110.73 13.9365 110.042 13.9365 108.939V105.44H12.6588V104.753H13.9365V102.796H14.6829Z"
      fill="currentColor"
    />,
    <path
      key="8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5668 110.73H21.8213V109.485C21.5132 110.386 20.7557 110.825 19.808 110.825C18.4584 110.825 17.5823 109.864 17.5823 108.382V104.753H18.3281V108.286C18.3281 109.401 18.9558 110.137 19.915 110.137C21.0278 110.137 21.8213 109.235 21.8213 107.966V104.753H22.5668V110.73Z"
      fill="currentColor"
    />,
    <path
      key="9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6262 105.44C25.312 105.44 24.9689 106.65 24.9689 108.18V110.73H24.2228V104.752H24.9689V106.021C25.2056 105.191 25.7024 104.752 26.6262 104.752H27.4073V105.44H26.6262Z"
      fill="currentColor"
    />,
    <path
      key="10"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.4451 108.844C33.2557 110.042 32.2258 110.825 30.7456 110.825C29.0524 110.825 27.8212 109.472 27.8212 107.693C27.8212 105.879 28.958 104.657 30.639 104.657C32.2729 104.657 33.3741 105.772 33.3741 107.421C33.3741 107.527 33.3621 107.729 33.3504 107.812H28.579C28.6263 109.152 29.5498 110.137 30.7456 110.137C31.7992 110.137 32.4626 109.663 32.6639 108.844H33.4451ZM28.6263 107.124H32.5926C32.5099 106.021 31.7758 105.345 30.639 105.345C29.5498 105.345 28.8157 106.009 28.6263 107.124Z"
      fill="currentColor"
    />,
    <path
      key="11"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.7163 102.428H38.5097V109.994H42.7604V110.73H37.7163V102.428Z"
      fill="currentColor"
    />,
    <path
      key="12"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.0341 108.844C48.8444 110.042 47.8149 110.825 46.3344 110.825C44.6414 110.825 43.4099 109.472 43.4099 107.693C43.4099 105.879 44.5467 104.657 46.228 104.657C47.8622 104.657 48.9631 105.772 48.9631 107.421C48.9631 107.527 48.9511 107.729 48.9391 107.812H44.168C44.2153 109.152 45.1388 110.137 46.3344 110.137C47.3882 110.137 48.0516 109.663 48.253 108.844H49.0341ZM44.2153 107.124H48.181C48.0989 106.021 47.3648 105.345 46.228 105.345C45.1388 105.345 44.4047 106.009 44.2153 107.124Z"
      fill="currentColor"
    />,
    <path
      key="13"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.0234 106.875V110.73H54.2776V109.639C53.9219 110.362 53.0934 110.825 52.134 110.825C50.8557 110.825 50.0386 110.125 50.0386 109.022C50.0386 107.883 50.9858 107.16 52.466 107.16H53.9102C54.1706 107.16 54.2776 107.053 54.2776 106.875C54.2776 105.974 53.6381 105.345 52.5253 105.345C51.6018 105.345 50.8201 105.926 50.7724 106.626H50.0266C50.1456 105.476 51.2824 104.657 52.5253 104.657C54.0876 104.657 55.0234 105.547 55.0234 106.875ZM54.2776 107.966V107.789H52.466C51.4715 107.789 50.832 108.263 50.832 109.022C50.832 109.698 51.3648 110.137 52.1939 110.137C53.5075 110.137 54.2776 109.342 54.2776 107.966Z"
      fill="currentColor"
    />,
    <path
      key="14"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.9052 105.44C57.591 105.44 57.2479 106.65 57.2479 108.18V110.73H56.5018V104.752H57.2479V106.021C57.4846 105.191 57.9817 104.752 58.9052 104.752H59.6864V105.44H58.9052Z"
      fill="currentColor"
    />,
    <path
      key="15"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.7507 104.752H61.4968V105.997C61.8049 105.096 62.5623 104.657 63.5095 104.657C64.8591 104.657 65.7352 105.618 65.7352 107.101V110.73H64.9894V107.195C64.9894 106.08 64.3623 105.345 63.4031 105.345C62.2903 105.345 61.4968 106.247 61.4968 107.515V110.73H60.7507V104.752Z"
      fill="currentColor"
    />,
    <path
      key="16"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.3086 103.637H68.2084V102.333H67.3086V103.637ZM67.391 110.73H68.1371V104.752H67.391V110.73Z"
      fill="currentColor"
    />,
    <path
      key="17"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.7939 104.753H70.5397V105.997C70.8478 105.096 71.6053 104.657 72.5524 104.657C73.9023 104.657 74.7784 105.618 74.7784 107.101V110.73H74.0326V107.196C74.0326 106.08 73.4052 105.345 72.4463 105.345C71.3332 105.345 70.5397 106.247 70.5397 107.515V110.73H69.7939V104.753Z"
      fill="currentColor"
    />,
    <mask
      key="18"
      id="mask1_5892_20983"
      maskUnits="userSpaceOnUse"
      x="76"
      y="104"
      width="6"
      height="10"
    >
      <path
        d="M76.1145 104.657H81.8333V113.149H76.1145V104.657Z"
        fill="white"
      />
    </mask>,
    <g key="19" mask="url(#mask1_5892_20983)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.8334 104.753V110.967C81.8334 112.236 80.9216 113.149 79.6427 113.149H76.884V112.462H79.6427C80.4835 112.462 81.0876 111.833 81.0876 110.967V109.84C80.8149 110.422 79.9628 110.825 79.0153 110.825C77.1207 110.825 76.1145 109.449 76.1145 107.741C76.1145 106.033 77.1207 104.657 79.0153 104.657C79.8441 104.657 80.7083 105.096 81.0876 105.713V104.753H81.8334ZM81.1697 107.741C81.1697 106.294 80.3295 105.345 79.0393 105.345C77.7481 105.345 76.9079 106.294 76.9079 107.741C76.9079 109.188 77.7481 110.137 79.0393 110.137C80.3295 110.137 81.1697 109.188 81.1697 107.741Z"
        fill="currentColor"
      />
    </g>,
    <path
      key="20"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.3898 96.7858C37.6396 96.7858 39.8617 93.0962 39.8617 88.2985V83.9204V76.5753H36.0396V88.0626C36.0396 91.2206 34.1875 93.0686 31.3898 93.0686"
      fill="currentColor"
    />,
    <path
      key="21"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.3897 96.7858C25.1396 96.7858 22.9175 93.0962 22.9175 88.2985V83.9204V76.5753H26.7397V88.0626C26.7397 91.2205 28.592 93.0686 31.3897 93.0686"
      fill="currentColor"
    />,
    <path
      key="22"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.8319 29.4745C39.93 24.5709 36.0287 20.6625 31.1333 18.7573C38.1268 16.0355 43.0992 9.22554 43.0992 1.26957V0.00012207H23.1069V17.4878V20.0267V34.9755V36.2453C23.1069 46.5843 31.5069 54.9962 41.8319 54.9962C52.1572 54.9962 60.5569 46.5843 60.5569 36.2453V34.9755V17.4878H59.2897C51.3475 17.4878 44.549 22.4689 41.8319 29.4745ZM58.0224 20.076V35.0233C51.6509 35.4528 46.1454 39.086 43.0992 44.3271V36.2453C43.0992 27.7298 49.6853 20.726 58.0224 20.076ZM40.5647 36.2453V44.3007C39.7593 42.919 38.7742 41.6309 37.6148 40.4694C34.3789 37.2277 30.1659 35.324 25.6417 35.0227V20.076C33.9789 20.726 40.5647 27.7298 40.5647 36.2453ZM25.6417 2.53903H40.5155C39.8992 10.4712 33.5602 16.8212 25.6417 17.4385V2.53903ZM25.6954 37.5684C33.5694 38.2078 39.869 44.5167 40.5107 52.4035C32.6343 51.7636 26.3342 45.4549 25.6954 37.5684ZM43.1525 52.4038C43.4607 48.5729 45.0983 45.013 47.8414 42.2648C50.586 39.5155 54.1421 37.8747 57.9691 37.5678C57.33 45.4544 51.029 51.7639 43.1525 52.4038Z"
      fill="currentColor"
    />,
    <path
      key="23"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.0692 0V2.5392H58.0221V13.511H60.5569V0H47.0692Z"
      fill="currentColor"
    />
  ],
  defaultProps: {
    "aria-label": "Euka logo",
    color: "text",
    w: "full",
    h: "full"
  }
});
